export enum AttachmentStatus {
    Unknown = "Unknown",
    Uploading = "Uploading",
    Uploaded = "Uploaded",
    Downloaded = "Downloaded",
    Downloading = "Downloading",
    UploadFailed = "UploadFailed",
    DownloadFailed = "DownloadFailed"
}